import { useEffect, useState } from "react";

/** Tiny hash router: `#/chantiers/<id>?tab=articles`. Keeps deep links working in Tauri, Capacitor and the PWA without a dependency. */
export interface Route { path: string; segments: string[]; query: URLSearchParams }
function parse(): Route {
  const raw = window.location.hash.replace(/^#\/?/, "");
  const [p = "", qs = ""] = raw.split("?");
  return { path: p, segments: p.split("/").filter(Boolean), query: new URLSearchParams(qs) };
}
export function useRoute(): Route {
  const [r, setR] = useState<Route>(() => (typeof window === "undefined" ? { path: "", segments: [], query: new URLSearchParams() } : parse()));
  useEffect(() => {
    const on = () => setR(parse());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return r;
}
export function navigate(path: string, query?: Record<string, string>) {
  const qs = query ? "?" + new URLSearchParams(query).toString() : "";
  window.location.hash = `/${path.replace(/^\//, "")}${qs}`;
}
